export class ErrorDetails {
    message: string = '';

    constructor(public title?: string) {
    }
}